import React from 'react';
import EventAddingWithCalendly from '../../components/CalendlyIntegration/EventAddingWithCalendly';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';

const EventAdding = ({
  suiteData,
  scheduling_url,
  propertyManagerDetails,
  onClose,
  onEventScheduled
}) => {
  return (
    <WithNavigation
      title="Properties"
      border
      top={(
        <EventAddingWithCalendly
          scheduling_url={scheduling_url}
          suiteData={suiteData}
          propertyManagerDetails={propertyManagerDetails}
          onEventScheduled={onEventScheduled}
          onClose={onClose}
        />
      )}
    />
  );
};

export default EventAdding;